<template>
  <modal-vue
    :modal-active="modelValue"
    has-header-border
    has-footer-border
    @close="handleClose"
    max-width="max-w-[600px]"
  >
    <template #header>
      <h2 class="text-xl font-bold text-textPrimary">Importar validações</h2>
    </template>

    <div class="flex flex-col gap-6">
      <p class="text-sm text-textSecondary">Selecione uma política para importar as validações</p>

      <div class="flex flex-col gap-4">
        <label class="flex items-center gap-3 cursor-pointer">
          <input
            v-model="selectedType"
            type="radio"
            value="TRANSFER_QUALIFICATION"
            data-testid="select-transfer-qualification-radio"
            class="w-5 h-5"
          />
          <span class="text-textPrimary">Qualificação para Repasse</span>
        </label>

        <label class="flex items-center gap-3 cursor-pointer">
          <input
            v-model="selectedType"
            type="radio"
            value="DOCUMENTARY_QUALIFICATION"
            data-testid="select-documental-qualification-radio"
            class="w-5 h-5"
          />
          <span class="text-textPrimary">Qualificação Documental</span>
        </label>
      </div>
    </div>

    <template #footer>
      <div class="flex items-center gap-4 w-full">
        <outlined-button
          data-testid="select-qualification-voltar-button"
          text="Voltar"
          width="100%"
          class="!border-primary30 !text-primary30 !font-bold flex-1"
          @click="handleClose"
        />
        <filled-button
          data-testid="select-qualification-selecionar-button"
          text="Selecionar arquivos"
          width="100%"
          :disabled="!selectedType"
          class="!bg-primary !text-white !font-bold hover:!bg-primary40 flex-1"
          @click="handleSelectType"
        />
      </div>
    </template>
  </modal-vue>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import type { QualificationPolicyType } from '@/modules/company/DsPolicy/components/ImportQualificationValidationsModal/types'

defineProps<{
  modelValue: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  'select-type': [type: QualificationPolicyType]
}>()

const selectedType = ref<QualificationPolicyType | null>(null)

const handleSelectType = () => {
  if (selectedType.value) {
    emit('select-type', selectedType.value)
    emit('update:modelValue', false)
    selectedType.value = null
  }
}

const handleClose = () => {
  selectedType.value = null
  emit('update:modelValue', false)
}
</script>
